
import React, { useEffect, useState } from "react";
import "../styles/alerts.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { socket, connectSocket } from "../services/socket";

export default function Alerts() {

    const [menuOpen, setMenuOpen] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const API_BASE = process.env.REACT_APP_API_URL || "";

    useEffect(() => {

        loadAlerts();

        connectSocket();

        socket.on("alert:new", (newAlert) => {

            setAlerts((current) => [
                {
                    ...newAlert,
                    id: Date.now(),
                    created_at: new Date().toISOString(),
                },
                ...current,
            ]);

        });

        return () => {
            socket.off("alert:new");
        };

    }, []);

    async function loadAlerts() {

        try {

            setLoading(true);
            setError("");

            const token = localStorage.getItem("token");

            const response = await fetch(`${API_BASE}/api/alerts`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to load alerts");
            }

            const data = await response.json();

            setAlerts(
                Array.isArray(data)
                    ? data
                    : data.alerts || []
            );

        } catch (err) {

            console.error("Alerts loading error:", err);
            setError("Unable to load alerts.");

        } finally {

            setLoading(false);

        }
    }

    function getSeverityClass(severity) {

        switch (severity) {

            case "critical":
                return "critical";

            case "warning":
                return "warning";

            case "info":
            default:
                return "info";
        }
    }

    function formatDate(date) {

        if (!date) return "-";

        return new Date(date).toLocaleString();
    }

    return (

        <div className="layout">

            <Sidebar
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
            />

            <div className="content">

                <Topbar
                    setMenuOpen={setMenuOpen}
                    title="Alerts"
                    subtitle="Inverter alerts and notifications"
                />

                <div className="alerts-page">

                    <div className="alerts-header">

                        <div>
                            <h1>Alerts</h1>

                            <p>
                                Monitor important inverter events and notifications.
                            </p>
                        </div>

                        <button
                            className="alerts-refresh"
                            onClick={loadAlerts}
                        >
                            Refresh
                        </button>

                    </div>

                    {loading && (

                        <div className="alerts-empty">
                            Loading alerts...
                        </div>

                    )}

                    {!loading && error && (

                        <div className="alerts-error">
                            {error}
                        </div>

                    )}

                    {!loading && !error && alerts.length === 0 && (

                        <div className="alerts-empty">

                            <div className="alerts-empty-icon">
                                ✓
                            </div>

                            <h2>No Alerts</h2>

                            <p>
                                Your inverters have no alerts at the moment.
                            </p>

                        </div>

                    )}

                    {!loading && !error && alerts.length > 0 && (

                        <div className="alerts-list">

                            {alerts.map((alert) => (

                                <div
                                    className={`alert-card ${getSeverityClass(
                                        alert.severity
                                    )}`}
                                    key={alert.id}
                                >

                                    <div className="alert-icon">

                                        {alert.severity === "critical"
                                            ? "!"
                                            : alert.severity === "warning"
                                                ? "⚠"
                                                : "ⓘ"}

                                    </div>

                                    <div className="alert-content">

                                        <div className="alert-top">

                                            <h3>
                                                {alert.title}
                                            </h3>

                                            <span
                                                className={`alert-severity ${getSeverityClass(
                                                    alert.severity
                                                )}`}
                                            >
                                                {alert.severity}
                                            </span>

                                        </div>

                                        <p className="alert-message">
                                            {alert.message}
                                        </p>

                                        <div className="alert-details">

                                            <span>
                                                <strong>Device:</strong>{" "}
                                                {alert.serial_number ||
                                                    alert.serial ||
                                                    "-"}
                                            </span>

                                            <span>
                                                <strong>Type:</strong>{" "}
                                                {alert.alert_type || "-"}
                                            </span>

                                            <span>
                                                <strong>Time:</strong>{" "}
                                                {formatDate(alert.created_at)}
                                            </span>

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>

                    )}

                </div>

            </div>

        </div>

    );
}
